import React from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { t } from 'ttag';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Divider from '@material-ui/core/Divider';
import PermissionChooser from '../../../components/PermissionChooser';
import Form from '../../../components/Form';
import Loading from '../../../components/Loading';
import FormBox from '../../../components/FormBox';
import useApi from '../../../api';
import useEditForm from '../../../hooks/useEditForm';
import useUser from '../../../auth/hooks';
import { USER_TYPE_OPTIONS } from '../../../utils/enums';

const SwitchGroup = ({ options, value, onChange }) => {
  const [state, setState] = React.useState({
    value,
  });
  const api = useApi();
  const { refetch } = useEditForm({
    schema: api.schema.users,
    router: api.router.permissions,
  });

  const handleChange = (e, item) => {
    let values = [];
    if (e.target.checked) {
      values = state.value.concat(item);
    } else {
      values = state.value.filter((t) => t !== item);
    }
    setState({ ...state, value: values });
    refetch();
    onChange({ target: { name: 'types', value: values } });
  };

  return (
    <FormGroup row>
      {options.map((option) => (
        <FormControlLabel
          key={option.id}
          control={
            <Switch
              checked={state.value.includes(option.id)}
              onChange={(e) => handleChange(e, option.id)}
              color='primary'
            />
          }
          label={option.label}
        />
      ))}
    </FormGroup>
  );
};

const BaseForm = ({ initial, onSubmit, errors }) => {
  const { user: authUser } = useUser();
  return (
    <Form onSubmit={onSubmit} initial={initial} errors={errors}>
      {({ data, change, submit }) => (
        <Grid container spacing={4}>
          <Grid>
            <Grid item sm={12}>
              {authUser.isAdmin && (
                <FormBox title={t`Роль`}>
                  <FormGroup row>
                    <SwitchGroup
                      options={USER_TYPE_OPTIONS}
                      value={data.types}
                      onChange={change}
                    />
                    <Grid item sm={6}>
                      <FormBox title={t`Налаштування`}>
                        <br />
                        <Divider />
                        <br />
                        <PermissionChooser
                          user_types={data.types}
                          selected={data.permissions}
                          permissionsGymIds={data.permissionsGymIds}
                          onChange={change}
                        />
                      </FormBox>
                    </Grid>
                  </FormGroup>
                </FormBox>
              )}
            </Grid>
          </Grid>
          <Button
            style={{ margin: '20px 0 20px 0' }}
            margin='normal'
            type='button'
            fullWidth
            variant='contained'
            color='primary'
            onClick={submit}
          >
            {t`Зберегти`}
          </Button>
        </Grid>
      )}
    </Form>
  );
};

const getInitialData = (row) => ({
  types: row.types || [],
  permissions: row.permissions || [],
  permissionsGymIds: row.permissionsGymIds || [],
});

export const EditForm = () => {
  const api = useApi();
  const { id, loading, data, onSubmit, errors } = useEditForm({
    schema: api.schema.users,
    router: api.router.permissions,
  });

  if (loading) return <Loading />;

  return (
    <>
      <h2>{t`Редагувати доступи: ${data.fullName}`}</h2>
      <Paper>
        <Box m={4}>
          <BaseForm
            id={id}
            initial={getInitialData(data)}
            data={data}
            onSubmit={onSubmit}
            errors={errors}
            edit
            showPasswordField={false}
          />
        </Box>
      </Paper>
    </>
  );
};
